<template>
  <div class=" lang-page page-padding-top">
    <top-bar :title="i18n.t('lang.title')"   @back="back"></top-bar>
    
    <div class="lang-list">
      <div class="list flex-center-between" v-for="(item, i) in langArr" :key="i" @click="changeLang(item)">
        <div>
          {{item.name}}
        </div>
        <div >
          <img :src="checkUrl2" alt="" v-if="item.key == lang">
          <img :src="checkUrl" alt="" v-else>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button } from 'vant'
import { langList } from '@/api/setting'
import topBar from '@/components/topBar'
import { LANGUAGE_LIST, getDefaultLanguage } from '@/i18n/languages'
export default {
  components: {
    Button,
    topBar
  },
  data() {
    return {
      lang: '',
      langArr: LANGUAGE_LIST, // 使用统一的语言列表配置
      checkUrl: require('../../assets/imgs/icon-checked.png'),
      checkUrl2: require('../../assets/imgs/icon-checked2.png')
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  mounted() {
    // this.init()
    let locale = localStorage.getItem('locale')
    const defaultLanguage = getDefaultLanguage()
    this.lang = locale ? locale : defaultLanguage

    // let langSettingList = this.language.split(',')
    // this.langArr = this.langArr.filter(v => {
    //   return langSettingList.indexOf(v.key) > -1
    // })


  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    init() {
      langList().then(res => {
        this.langArr = res.data.Items
      })
    },
    changeLang(data) {
      this.lang = data.key
      localStorage.setItem('locale', data.key)
      localStorage.setItem('localeName', data.name)
      this.i18n.locale = data.key
      setTimeout(() => {
        this.back()
      }, 500)
    }
  }
}
</script>